import { useEffect, useState } from "react";
import InputComponent from "../../../../shared/input/InputComponent";
import SelectComponent from "../../../../shared/select/SelectComponent";
import styles from "./UploadInvoie.module.scss";
import fileimg from "../../../../../assets/images/packages/FilePlus.svg";
import { OrdersService } from "../../../../../services/orders.service";
import MainButton from "../../../../shared/button/MainButton";
import { InvoiceService } from "../../../../../services/invoice.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import CloseIcon from "../../../../../assets/images/modal-icon/CloseIcon.svg";

interface UploadInvoieProps {
  trackId: string;
  packId: number | null;
  countryId: number | null;
  onCloseModal?: () => void;
  onSuccess?: (newInvoiceDoc: string) => void;
  fetchPackagesType?: () => void;
  fetchPackages?: () => void;
  invoiceData: {
    seller_id: undefined;
    category_id: undefined;
    currency_id: undefined;
    other_seller: "";
    price: "";
    title: string;
  };
}

interface OrdersType {
  name: string;
  title: string;
  id: number;
  country_ids: number[];
}

interface InvoicePayload {
  seller_id?: number;
  category_id?: number;
  currency_id?: number;
  other_seller?: string;
  price?: string;
  productName?: string;
  invoice?: File | null;
}

const UploadInvoie = ({
  trackId,
  packId,
  onCloseModal,
  fetchPackagesType,
  onSuccess,
  fetchPackages,
  countryId,
  invoiceData,
}: UploadInvoieProps) => {
  const [categories, setCategories] = useState<OrdersType[]>([]);
  const [sellers, setSellers] = useState<OrdersType[]>([]);
  const [currency, setCurrency] = useState<OrdersType[]>([]);
  const language = useSelector((state: RootState) => state.language.language);
  const { data } = useSelector((state: RootState) => state.translationData);
  const [formData, setFormData] = useState<InvoicePayload>({
    seller_id: undefined,
    category_id: undefined,
    currency_id: undefined,
    other_seller: "",
    price: "",
    productName: "",
    invoice: null,
  });
  const isButtonDisabled =
    !formData.category_id ||
    !formData.currency_id ||
    !formData.price ||
    !formData.productName ||
    !formData.invoice ||
    (formData.seller_id === 0 && !formData.other_seller?.trim());

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  useEffect(() => {
    OrdersService.getAllSellers().then((res) => setSellers(res.data.sellers));
    OrdersService.getAllStoreCategory().then((res) =>
      setCategories(res.data.categories)
    );
    OrdersService.getAllStoreCurrency().then((res) =>
      setCurrency(res.data.currencies)
    );
  }, [language]);

  const getDefaultCurrency = () => {
    const matchedCurrency = currency.find((cur) =>
      cur.country_ids.includes(countryId || 0)
    );
    return matchedCurrency ? matchedCurrency.id : undefined;
  };
  useEffect(() => {
    const defaultCurrencyId = getDefaultCurrency();
    setFormData((prevData) => ({
      ...prevData,
      currency_id: defaultCurrencyId,
    }));
  }, [countryId, currency]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => {
      if (prevErrors[name]) {
        const { [name]: _, ...rest } = prevErrors;
        return rest;
      }
      return prevErrors;
    });
  };

  const handleSelectChange = (
    name: string,
    value: number | string | undefined
  ) => {
    const parsedValue =
      value === "" || value === undefined || value === null
        ? undefined
        : Number(value);

    const finalValue =
      name === "seller_id" && parsedValue === -1 ? 0 : parsedValue;

    setFormData((prev) => {
      const updatedForm = { ...prev, [name]: finalValue };

      if (name === "seller_id" && finalValue !== 0) {
        updatedForm.other_seller = "";
      }

      return updatedForm;
    });

    setErrors((prevErrors) => {
      if (prevErrors[name]) {
        const { [name]: _, ...rest } = prevErrors;
        return rest;
      }
      return prevErrors;
    });
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      try {
        const arrayBuffer = await file.arrayBuffer();
        
        const newFile = new File([arrayBuffer], file.name, {
          type: file.type,
          lastModified: Date.now()
        });
        
        setFormData((prev) => ({ ...prev, invoice: newFile }));
        
        console.log('Fayl uğurla hazırlandı:', file.name);
      } catch (error) {
        console.error('Fayl oxunarkən xəta:', error);
        toast.error(data?.error_occurred || 'Fayl yüklənərkən xəta baş verdi');
      }
    }
  };

  const handleSave = async () => {
    const formDataToSend = new FormData();
    if (formData.seller_id !== undefined)
      formDataToSend.append("seller_id", formData.seller_id.toString());
    if (formData.category_id)
      formDataToSend.append("category_id", formData.category_id.toString());
    if (formData.currency_id)
      formDataToSend.append("currency_id", formData.currency_id.toString());
    if (formData.other_seller)
      formDataToSend.append("other_seller", formData.other_seller);
    if (formData.price) formDataToSend.append("price", formData.price);
    if (formData.productName)
      formDataToSend.append("productName", formData.productName);
    if (formData.invoice) formDataToSend.append("invoice", formData.invoice);

    await InvoiceService.uploadInvoice(packId!, formDataToSend)
      .then((response) => {
        if (response?.status === 200 && response?.data?.original?.items) {
          toast.success(data?.invoice_added);
          onSuccess?.(response.data.original.items);
          onCloseModal?.();
          fetchPackagesType?.();
          fetchPackages?.();
          return;
        }
        if (response?.status === 200) {
          const errorMessage = response?.data?.content;
          setErrors(errorMessage);
        }
      })
      .catch((error: any) => {
        // console.log(error.data.original.content);
        const errorMessage =
          error?.data?.original?.content || data?.error_occurred;

        toast.error(errorMessage);
      });
  };

  useEffect(() => {
    if (invoiceData) {
      setFormData((prev) => ({
        ...prev,
        seller_id: invoiceData?.seller_id ?? undefined,
        category_id: invoiceData?.category_id ?? undefined,
        currency_id: invoiceData?.currency_id ?? getDefaultCurrency(),
        other_seller: invoiceData?.other_seller || "",
        price: invoiceData?.price || "",
        productName: invoiceData?.title || "",
      }));
    }
  }, [invoiceData, currency]);

  return (
    <div className={styles.invoice_doc}>
      <div className={styles.close_buttonContainer}>
        <button className={styles.close_button} onClick={onCloseModal}>
          <img src={CloseIcon} alt="" />
        </button>
      </div>
      <div className={styles.upload_invoice}>
        <div className={styles.upload_inputs}>
          <InputComponent
            label={data?.auth_common_tracking_code}
            type="text"
            placeholder="Tracking code"
            name="TrackId"
            disabled
            value={trackId}
          />
        </div>
        <div className={styles.upload_inputs}>
          <SelectComponent
            name="seller_id"
            label={data?.stores}
            placeholder={data?.stores}
            value={formData.seller_id}
            selectedValue={formData.seller_id}
            options={[
              { label: `${data?.auth_attorney_select}`, value: "" },
              ...sellers.map((seller) => ({
                label: seller.title,
                value: seller.id,
              })),
              { label: `${data?.other}`, value: -1 },
            ]}
            onChange={(value) => handleSelectChange("seller_id", Number(value))}
          />
        </div>
        <div className={styles.upload_inputs}>
          <SelectComponent
            name="category_id"
            label={data?.auth_common_category}
            value={formData.category_id}
            selectedValue={formData.category_id}
            placeholder={data?.auth_common_category}
            options={categories.map((category) => ({
              label: category.name,
              value: category.id,
            }))}
            onChange={(value) =>
              handleSelectChange("category_id", Number(value))
            }
            error={errors.category_id}
          />
        </div>
        <div className={styles.upload_inputs}>
          <InputComponent
            label={data?.other_store}
            type="text"
            placeholder={data?.store_name}
            name="other_seller"
            value={formData.other_seller}
            onChange={handleInputChange}
            disabled={formData.seller_id !== 0}
          />
        </div>
        <div className={styles.upload_inputs}>
          <InputComponent
            label={data?.auth_package_containings}
            type="text"
            placeholder={data?.auth_package_containings}
            name="productName"
            value={formData.productName}
            onChange={handleInputChange}
          />
        </div>
        <div className={styles.upload_inputs}>
          {/* <SelectComponent
            name="currency_id"
            label="Valyuta"
            options={currency.map((currrency) => ({
              label: currrency.name,
              value: currrency.id,
            }))}
            onChange={(value) =>
              handleSelectChange("currency_id", Number(value))
            }
            error={errors.category_id}
          /> */}
          <SelectComponent
            name="currency_id"
            label={data?.auth_currency}
            options={currency.map((currrency) => ({
              label: currrency.name,
              value: currrency.id,
            }))}
            selectedValue={formData.currency_id ?? undefined}
            value={formData.currency_id ?? undefined}
            onChange={(value) =>
              handleSelectChange("currency_id", Number(value))
            }
            error={errors.currency_id}
          />
        </div>
        <div className={styles.upload_inputs}>
          <InputComponent
            label={data?.product_price}
            type="number"
            placeholder={data?.product_price}
            name="price"
            value={formData.price}
            onChange={handleInputChange}
            error={errors.price}
          />
        </div>{" "}
        <div className={styles.custom_file_upload}>
          <label>
            <input
              id="file-upload"
              type="file"
              // accept="image/*,application/pdf"
              onChange={handleFileChange}
            />
            <div className={styles.file_inp_text}>
              <img src={fileimg} alt="" />

              {formData.invoice ? (
                <p>{formData.invoice.name || data?.uploaded_invoice}</p>
              ) : (
                <p>{data?.auth_common_upload_invoice}</p>
              )}
            </div>
          </label>
          <p className={styles.errorMsg}> {errors.invoice}</p>
        </div>
        <MainButton
          onClick={handleSave}
          className={styles.invoice_btn}
          type="button"
          text={data?.save}
          disabled={isButtonDisabled}
        />
      </div>
    </div>
  );
};

export default UploadInvoie;
